import React, { useState } from 'react';
import { FiPlus, FiUpload } from 'react-icons/fi';
import { QuotesBookingsProvider } from '../quotes/QuotesBookingsContext';
import Button from '../ui/Button';
import QuickCreateShipmentModal from './QuickCreateShipmentModal';

const QuickCreateShipmentAction = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <QuotesBookingsProvider>
      <div style={{ display: 'flex', gap: '12px' }}>
        <Button variant="secondary" leadingIcon={<FiUpload />}>
          Import Loads
        </Button>
        <Button variant="primary" leadingIcon={<FiPlus />} onClick={() => setIsModalOpen(true)}>
          New Shipment
        </Button>
      </div>
      <QuickCreateShipmentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </QuotesBookingsProvider>
  );
};

export default QuickCreateShipmentAction;
